import qs from 'qs';
import { network } from 'services/network';

export const deleteUser = (params) => {
    const querystring = qs.stringify(
        { userName: params.email },
        { addQueryPrefix: true, skipNulls: true, encode: true },
    );
    let url = `admin/bo/delete${querystring}`;
    return network.post(url).then((response) => response.data);
};
